import { StreakCalendarMonths } from './StreakCalendarMonths'
import { StreakCalendarLegend } from './StreakCalendarLegend'
import { StreakCalendarGrid } from './StreakCalendarGrid'
import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'

interface Props {
  hideMonthTabs?: boolean
}

export const StreakCalendar = ({ hideMonthTabs = false }: Props) => {
  return (
    <FlexBox
      className={css`
        gap: 20px;
      `}
      flexDirection="column"
    >
      {hideMonthTabs ? null : <StreakCalendarMonths />}
      <StreakCalendarGrid />
      <StreakCalendarLegend />
    </FlexBox>
  )
}
